import { List } from "@material-ui/core";
import { TastingAnswer } from "store/reducers/answers/reducer";
import { ReminderMode } from "store/reducers/events/reducer";
import TastingAnswerItem from "./tasting-answer-item";

export type TastingAnswersProps = {
    answers: TastingAnswer,
    showForBartender?: boolean,
    editingAllowed?: boolean,
    reminderMode?: ReminderMode | null,
    onClickItemAtIndex?: (index: number) => void;
}

const TastingAnswers = ({
    answers,
    showForBartender = false,
    editingAllowed = false,
    reminderMode = "off",
    onClickItemAtIndex
}: TastingAnswersProps) => {
    const beersSelected = answers?.beers ?? [];
    const ratingsSelected = answers?.ratings ?? [];
    const asterisksSelected = answers?.asterisks ?? [];
    const doubleAsterisksSelected = answers?.doubleAsterisks ?? [];
    const lottoLocoSelected = answers?.lottoLoco ?? [];
    const secondaryBeersSelected = answers?.secondaryBeers ?? [];
    const notesSelected = answers?.notes ?? [];
    const showAsPoured = showForBartender ?? false;
    const rounds = answers?.rounds ?? 0;
    const showReminder = reminderMode === "secondary" || reminderMode === "both";
    const showNotes = reminderMode === "notes" || reminderMode === "both";

    const renderItems = () => {
        let index, items = [];
        for (index = 0; index < rounds; index++) {
            const selectedBeer = beersSelected[index];
            const rating = ratingsSelected[index];
            const asterisk = asterisksSelected[index];
            const doubleAsterisk = doubleAsterisksSelected[index];
            const isLottoLoco = Boolean(lottoLocoSelected[index]);
            const secondaryBeer = showReminder ? (secondaryBeersSelected[index] ?? null) : null;
            const note = showNotes ? (notesSelected[index] ?? null) : null;
            const round = index;
            const onClick = () => (onClickItemAtIndex && onClickItemAtIndex(round));
            items.push(<TastingAnswerItem
                key={index}
                roundIndex={index}
                selectedBeer={selectedBeer}
                rating={rating}
                hasAsterisk={asterisk}
                hasDoubleAsterisk={Boolean(doubleAsterisk)}
                isLottoLoco={isLottoLoco}
                showAsPoured={showAsPoured}
                canEdit={editingAllowed}
                secondaryBeer={secondaryBeer}
                note={note}
                onClick={onClick}
            />
            );
        }
        return items;
    }

    return (
        <List>
            {renderItems()}
        </List>
    );
}
export default TastingAnswers;